module.exports = __webpack_public_path__ + "img/nanyida_result02.d059ddcf.png";